import React from 'react';

const ElseNonMemoed = ({ condition, children = null, alt = null }) => {
    return !condition ? children : alt;
};

const Else = React.memo(ElseNonMemoed);
export default Else;